export default {
    methods: {
        openSite(site) {
            window.open(`http://www.${site}`, '_blank');
        }
    }
}